import React from "react";
import { animations } from "helpers/animations";
import { useInactivitySession } from "hooks/useInactivitySession";

export const InactivityTimer = React.memo(() => {
  const timeCounter = useInactivitySession();

  return (
    <span className={animations.fadeIn}>
      min: {timeCounter.min} seg: {timeCounter.seg}
    </span>
  );
});